import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
    return <div className={cn('rounded-md bg-neutral-500/10 dark:bg-neutral-50/10', className)} {...props} />;
}

export { Skeleton };
